import script from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=ecdf0cc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecdf0cc2"]])

export default __exports__